export function isDynamicImportLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return /dynamically imported module|loading chunk|failed to fetch.*module|importing a module script/i.test(message);
}

export async function recoverAppResources() {
  if (typeof window === "undefined") return;
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
  const url = new URL(window.location.href);
  url.searchParams.set("mh_resource_reload", Date.now().toString(36));
  window.location.replace(url.toString());
}
